import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isShow: false
  },
  getters: {
  },
  mutations: {
    changeShowState (state, payload) {
      state.isShow = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
